import AXIOS from "./axios";

export class Reports {
  static getNeighborhoodStatus() {
    return AXIOS.get("/institutions/reports/neighborhoods_statuses");
  }

  static getStatuses() {
    return AXIOS.get("/institutions/reports/statuses_by_age");
  }

  static getCitiesStatuses() {
    return AXIOS.get("/institutions/reports/cities_statuses");
  }
}
